import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-control_field",
  "use": "icon-control_field-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-control_field\"><g transform=\"translate(3 2)\" stroke=\"currentColor\" fill=\"transparent\"><ellipse cx=\"5.53\" cy=\"2.653\" rx=\"4.947\" ry=\"2.153\" /><path d=\"M.545 6.366c0 1.172 2.144 2.132 4.985 2.132 2.84 0 4.925-.96 4.925-2.132M.495 9.878C.495 11.05 2.689 12 5.53 12c2.84 0 4.925-.95 4.925-2.122\" /><path stroke-linecap=\"round\" d=\"M10.455 10.08V2.653M.495 10.08l.099-7.427\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol